import React from 'react'
import axios from '~/data/http/axios';
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import SmallLineGraph from '~/Common-Objects/UI/Graphs/SmallLineGraph/SmallLineGraph'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import InitialSetup from './initial';
import Disconnect from './disconnect';
import ApplicationTransactionsGraph from '../components/applicationTransactionsGraph'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'

//CONNECT TO STORE
@connect((store) => {
    return { user: store.user, permissionStore: store.permission, siteMaster: store.siteMaster }
})


export default class HubspotConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: "",
            loading: true,
            appData: {},
            appBinding: {},
            groups: [],
            importing: false,
            importProgress: 0,
            importId: undefined,
            unloading: false
        };

        this.getApp = this.getApp.bind(this);
        this.getAppBinding = this.getAppBinding.bind(this);
        this.popDisconnect = this.popDisconnect.bind(this);
        this.getGroups = this.getGroups.bind(this)
        this.setup = this.setup.bind(this)
        this.checkForImportUpdate = this.checkForImportUpdate.bind(this)
        this.performSync = this.performSync.bind(this)
    }

    componentDidMount() {
        this.getApp();
    }

    componentWillUnmount() {
        this.setState({
            unloading: true
        })
    }


    getApp(response) {
        if (response && response.data && response.data.id) {
            this.setState({
                importing: true,
                importId: response.data.id
            }, this.checkForImportUpdate)
        }
        axios.get("/application/48").then(response => {
            this.setState({
                appData: response.data.Application
            }, this.getAppBinding)
        })
    }

    getAppBinding() {
        axios.get("/application/account/app/" + this.state.appData.id).then(response => {
            var groupId = -1;
            if (response.data.Application.appSettings && response.data.Application.appSettings.groupId) groupId = response.data.Application.appSettings.groupId;

            this.setState({
                appBinding: response.data.Application,
                groupId: groupId
            }, this.getGroups)
        })
    }

    getGroups() {
        axios.get('/group').then(response => {
            this.setState({
                groups: response.data.Groups,
                loading: false
            })
        })
    }

    checkForImportUpdate() {
        if (this.state.unloading) return;
        var self = this;
        axios.get('/group/' + this.state.appBinding.appSettings.groupId + '/import/' + this.state.importId).then(res => {
            self.setState({ importProgress: res.data.PercentComplete })
            if (res.data.PercentComplete < 100) {
                this.theTimer = setTimeout(this.checkForImportUpdate, 1000);
            }
            else {
                self.setState({ importing: false, importProgress: 100 }, this.getAppBinding)
            }
        })
    }

    popDisconnect() {
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, "right", <Disconnect goDisconnect={() => {
            axios.delete('/accountMaster/application/' + this.state.appBinding.id).then(res => {
                this.props.history.push('/cp/company/integrations')
            })
        }} />, true, "500px"));
    }

    setup(only) {
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, "right", <InitialSetup only={only} appBinding={this.state.appBinding} finish={response => {
            this.props.dispatch(siteMaster.alterSiteDrawer(false))
            this.getApp(response);
        }} />, true, "500px"));
    }

    performSync() {
        axios.get('/application/nimble/sync').then(response => {
            if (response.data.id) {
                this.setState({
                    importing: true,
                    importId: response.data.id
                }, this.checkForImportUpdate)
            }
        })
    }

    render() {

        if (this.state.loading) return <LoadingIcons iconType="2" />

        var currentGroup = this.state.groups.find(g => g.id == this.state.appBinding.appSettings.groupId)
        if (!currentGroup) return <InitialSetup appBinding={this.state.appBinding} finish={this.getApp} />


        return <div>
            <Row className="middle-xs mar-b10">
                <Column xs={12} sm={12} md={4} lg={4} className="col-md-offset-2">
                    <div className="quickFlex">
                        <div className="integration-avatar rounded" style={{ backgroundImage: "url(" + this.state.appData.appLogoUri + ")" }}></div>
                        <p className="no-marg pad-left">Nimble. Connected</p>
                    </div>
                </Column>
                <Column xs={12} sm={12} md={4} lg={4} className="end-xs">
                    <p className="no-marg">
                        <Button className="button-sml grey" onClick={this.popDisconnect}>
                            Disconnect
                        </Button>
                    </p>
                </Column>
            </Row>
            <Row>
                <Column xs={12} sm={12} md={4} lg={4} className="col-md-offset-2">
                    <Paper className="height-100 mar-b0">
                        <h4 className="mar-b25 text-primary">Contacts</h4>
                        <p>Nimble is currently connected. If you want to resync your contact list into Transpond then click <a onClick={this.performSync}>here</a></p>
                        <p>
                            <div className="chip smallChip outline secondary" onClick={() => { this.props.history.push('/cp/groups/' + this.state.groupId); }}>{currentGroup.groupName}</div>
                            {!this.state.importing && this.state.appBinding.appSettings && this.state.appBinding.appSettings.lastSynced && <div className="text-xsml">Last synced: {DateTimeFunctions.formatDateTime(this.state.appBinding.appSettings.lastSynced, 1)} - <a onClick={this.performSync}>Re-sync</a></div>}
                        </p>
                        <Row>
                            <Column xs={6}><Button className="full-width button-md outline primary" onClick={() => this.setup('group')}>Change Group</Button></Column>
                            <Column xs={6}><Button className="full-width button-md outline primary" onClick={() => this.setup('fields')}>Select Fields</Button></Column>
                        </Row>
                        {/* {!this.state.importing && <div className="mar-t10 text-sml text-underlined"><a onClick={this.performSync}>Sync Now</a></div>} */}
                        {this.state.importing && <div style={{ marginTop: "10px" }}><p>Performing Sync</p> <SmallLineGraph width="100%" height="5" hideText={true} val1={this.state.importProgress} val2={100} /></div>}
                    </Paper>
                </Column>
                <Column xs={12} sm={12} md={4} lg={4}>
                    <Paper className="height-100 mar-b0">
                        <h4 className="text-primary">Sync history</h4>
                        <ApplicationTransactionsGraph applicationId={this.state.appData.id} />
                    </Paper>
                </Column>
            </Row>
        </div>
    };


};


